import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { toast } from 'sonner';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import AuthLayout from './components/AuthLayout';
import apiClient from '../../lib/apiClient';
import { useLogin } from './api/auth';
import { ValidationErrors } from './types';
import { useAuthStore } from '../../store/useAuthStore';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { mutateAsync: login, isPending } = useLogin();
  
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState<ValidationErrors>({});

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrors({});
    
    try {
      const { data } = await apiClient.post('/admin/login', formData);
      localStorage.setItem('admin_token', data.token);
      useAuthStore.getState().setUser(data.user);
      navigate('/');
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'An error occurred during login.');
    }
  };

  return (
    <AuthLayout 
      title="Admin Console" 
      subtitle="Enter your administrator credentials to secure access."
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <Input 
          label="Administrator Email" 
          type="email" 
          placeholder="Enter email"
          required 
          value={formData.email}
          onChange={(e) => setFormData({...formData, email: e.target.value})}
          error={errors.email?.[0]}
        />
        
        <div>
          <Input 
            label="Secure Password" 
            type="password" 
            placeholder="••••••••" 
            required 
            value={formData.password}
            onChange={(e) => setFormData({...formData, password: e.target.value})}
            error={errors.password?.[0]}
          />
          {/* <div className="flex justify-end mt-2">
            <Link to="/admin/forgot-password" className="text-sm font-semibold text-brand-700 hover:text-slate-800 transition-colors">
              Recover access
            </Link>
          </div> */}
        </div>

        <Button type="submit" fullWidth isLoading={isPending}>
          Authenticate
        </Button>
      </form>
    </AuthLayout>
  );
}